

/**
 * Convertit une valeur (nombre, chaîne "12.5" / "12,5", null...) en Number.
 * Retourne NaN si la conversion est impossible.
 */
function toNumber(value) {
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'string' && value.trim() !== '') {
        return parseFloat(value.replace(/\s/g, '').replace(',', '.'));
    }
    return NaN;
}

let NumberFormatter = {
    toNumber: toNumber,

    formatFloat: function(number, decimals, append) {
        let value = toNumber(number);
        let formatted = isNaN(value) ? '0' : value.toFixed(decimals == null ? 2 : decimals).replace('.', ',');

        if (append) {
            formatted += append;
        }
        return formatted;
    },

    formatMoney: function(amount, append) {
        let value = toNumber(amount);

        if (isNaN(value)) {
            return '';
        }

        let formatted = value.toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',');

        if (append) {
            formatted += append;
        }
        return formatted;
    }
};

window.NumberFormatter = NumberFormatter;

/**
 * Parse un nombre décimal dans un champ
 */
$.fn.parseFloat = function() {
    let value = this.is('input, select') ? this.val() : this.text();

    if (undefined === value) {
        return undefined;
    }

    return parseFloat(value.replace(',', '.'))
};

/**
 * Formatte un nombre flottant dans un champ texte
 *
 * Le nombre de décimales est paramétrable, et a comme défaut 2
 */
$.fn.formatFloat = function(number, decimals) {
    let formatted = NumberFormatter.formatFloat(number, decimals);

    if (this.is('input')) {
        this.val(formatted)
    } else {
        this.text(formatted)
    }
};

/**
 * Parse un nombre entier dans un champ
 */
$.fn.parseInt = function() {
    let value = this.is('input') ? this.val() : this.text();

    if (undefined === value) {
        return undefined;
    }

    return parseInt(value)
};

/**
 * Formatte un montant et inscrit sa valeur dans le champ courant.
 *
 * Le nombre de décimales est paramétrable est a comme défaut 2
 *
 * Les chiffres sont séparés par un espace tous les milliers.
 */
$.fn.formatMoney = function(amount, append) {
    let formatted = NumberFormatter.formatMoney(amount, append);

    if (this.is('input')) {
        this.val(formatted)
    } else {
        this.text(formatted)
    }
};

/**
 * Parse le montant d'un champ monnaie en nombre flottant
 */
$.fn.parseMoney = function() {
    let value = this.is('input') ? this.val() : this.text();

    return parseFloat(value.replace(/ /g, '').replace(',', '.'))
};


// WEBPACK FOOTER //
// ./js/form/form.js